import React from 'react';
import BaseComponent from './BaseComponent';
import Button from './Button';
import Style from './QuizIndicator.cssmodule.less';
import { CompletedIndicatorList } from '../../Constants';

class QuizIndicator extends BaseComponent {
    constructor(props) {
        super(props);
    }

    createIndicator() {
        const indicator = [];
        let isLast = true;
        for (let i = this.props.content.length - 1; i >= 0; i--) {
            const content = this.props.content[i];
            const { status = 'BASIC', value = {} } = content;
            const { questionsCount = 0, correctCount = 0 } = value;
            let indicatorStyle = '';
            let indicatorText = 'Q';
            if (CompletedIndicatorList.indexOf(status) > -1) {
                indicatorStyle = 'completeBox';
                if (isLast) {
                    indicatorStyle += ' last';
                    isLast = false;
                }
                indicatorText = `${correctCount}/${questionsCount}`;
            } else {
                indicatorStyle = 'basicBox';
                if (i === 0) {
                    indicatorStyle += ' first';
                }
            }

            indicator.unshift(
                <Button
                    key={`indicatorButton${i}`}
                    className={`${Style.indicator} ${status} ${indicatorStyle}`}
                    onClick={(e) => {
                        if ('onClick' in this.props) {
                            this.props.onClick(e, i);
                        }
                    }}
                >
                    <span>{indicatorText}</span>
                </Button>
            );
        }

        return <div>{indicator}</div>;
    }

    createIndicatorName() {
        let className = `${this.props.className} `;
        return `${className}${Style.quizIndicator}`;
    }

    render() {
        return (
            <div className={this.createIndicatorName()}>
                {this.createIndicator()}
            </div>
        );
    }
}

QuizIndicator.displayName = 'QuizIndicator';
QuizIndicator.propTypes = {};

export default QuizIndicator;



// WEBPACK FOOTER //
// ./components/CommonSet/QuizIndicator.js